module.exports = __webpack_public_path__ + "img/error@2x.61add3cc.png";